import { render, staticRenderFns } from "./bank-cardbin-manag.vue?vue&type=template&id=880894b2"
import script from "./bank-cardbin-manag.vue?vue&type=script&lang=js"
export * from "./bank-cardbin-manag.vue?vue&type=script&lang=js"
import style0 from "./bank-cardbin-manag.vue?vue&type=style&index=0&id=880894b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports